import script from "./Comment.vue?vue&type=script&lang=ts&setup=true"
export * from "./Comment.vue?vue&type=script&lang=ts&setup=true"

import "./Comment.vue?vue&type=style&index=0&id=f8e4ae62&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8e4ae62"]])

export default __exports__